module.exports = __webpack_public_path__ + "static/media/NftSoccerGames.4cb6af1e.jpg";